module.exports = __webpack_public_path__ + "img/00042.76c4ec60.webp";